import { useEffect } from 'react'

interface UseKeyboardNavigationOptions {
  onNext: () => void
  onPrevious: () => void
  onConfirm: () => void
  onEscape: () => void
  enabled?: boolean
}

export function useKeyboardNavigation({
  onNext,
  onPrevious,
  onConfirm,
  onEscape,
  enabled = true,
}: UseKeyboardNavigationOptions) {
  useEffect(() => {
    if (!enabled) return

    const handleKeyDown = (e: KeyboardEvent) => {
      // Don't interfere with typing in input fields
      if (e.target instanceof HTMLInputElement || e.target instanceof HTMLTextAreaElement) {
        return
      }

      switch (e.key) {
        case 'ArrowDown':
        case 'ArrowRight': {
          e.preventDefault()
          onNext()
          break
        }
        case 'ArrowUp':
        case 'ArrowLeft': {
          e.preventDefault()
          onPrevious()
          break
        }
        case 'Enter': {
          onConfirm()
          break
        }
        case 'Escape': {
          onEscape()
          break
        }
      }
    }

    window.addEventListener('keydown', handleKeyDown)
    return () => window.removeEventListener('keydown', handleKeyDown)
  }, [onNext, onPrevious, onConfirm, onEscape, enabled])
}
